import React from 'react';
import CartGridItem from './CartGridItem';
import { translate } from '../../Services/translation';

const CartGridSearchResults = ({ orderRows }) => {
  return (
    <div className='cart-grid-wrapper'>
      <div className='cart-grid cart-grid--search-results cart-grid--striped'>
        <div className='cart-grid__header'>
          <div>{/* Img */}</div>
          <div>{/* Name */}</div>
          <div> {translate("product.weightpersalesunit")} </div>
        </div>
        {orderRows &&
          orderRows.map((order, index) => (
            <CartGridItem
              item={order}
              inactive={false}
              loading={false}
              showQuantityColumn={false}
              showPricePerUnitColumn={false}
              showStockColumn={false}
              showDeliveryDateColumn={false}
              showWeightColumn={true}
              showSpecDeleteBtn={false}
              key={'cartitem-' + index}
            ></CartGridItem>
          ))}
      </div>
    </div>
  );
};

export default CartGridSearchResults;
